import { Navigate, useLocation } from 'react-router-dom'
import useAuth from 'app/hooks/useAuth'
import JwtLogin from '../views/sessions/JwtLogin'
import MatxLayout from '../components/MatxLayout/MatxLayout'
import { MatxLoading } from 'app/components'

const AuthGuard = () => {
  const { isAuthenticated, isInitialised } = useAuth()
  const { pathname } = useLocation()

  if (!isInitialised) {
    return <MatxLoading />
  }

  if (isAuthenticated) {
    if (pathname === "/session/signin") {
      return <Navigate replace to="/" />
    }
    return <MatxLayout />
  } else {
    if (pathname === "/session/signin") {
      return <JwtLogin />
    }
    return <Navigate replace to="/session/signin" state={{ from: pathname }} />
  }
}

export default AuthGuard
